module.exports = __webpack_public_path__ + "static/media/loading_indicator_bg@2x.3f4d4434.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/loading_Indicator/loading_indicator_bg@2x.png
// module id = 455
// module chunks = 0